// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"498":"e4f4accc","722":"ac85ff29"}[chunkId] + ".css";
};